import ReactInputMask from "react-input-mask";
import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1000px;
  display: flex;
  overflow-x: auto;
  flex-direction: column;

  h1 {
    margin-bottom: 0px;
    font-family: Montserrat;
    color: #000;
  }

  h3 {
    width: 100%;
    font-size: 18px;
    margin-bottom: 10px;
    font-family: Montserrat;
  }

  @media (max-width: 750px) {
    width: 95%;
    h1 {
      text-align: left;
      font-size: 22px;
      margin-bottom: 5px;
    }
  }

  .row {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .service {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    font-size: 14px;
    font-weight: 600;
    color: #000;
    border-bottom: 1px solid #afafaf;
  }

  .button {
    background-color: #007a3e;
    color: #fff;
    &:hover {
      background-color: #007a3ecc;
    }
  }

  .checkout-summary {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background-color: #f1f1f1;
    margin-top: 15px;
    font-weight: 600;
    flex-wrap: wrap;
  }

  .left-section {
    flex: 1;
    min-width: 250px;
  }

  .button {
    background-color: #007a3e;
    color: #fff;
    &:hover {
      background-color: #007a3ecc;
    }
  }

  .discount-info {
    margin: 10px 0;
    font-size: 14px;
    font-weight: 800;
  }

  .right-section {
    text-align: right;
    flex: 1;
    min-width: 250px;
  }

  .line {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;
    gap: 10px;
  }

  .badge {
    background-color: #007a3e;
    color: white;
    padding: 6px;
    border-radius: 5px;
    font-size: 15px;
  }

  .final-label {
    font-weight: bold;
  }

  .amount {
    background: white;
    padding: 6px 8px;
    border-radius: 5px;
    font-size: 15px;
    font-weight: bold;
  }
`;

export const Contact = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 10px;
  margin-bottom: 15px;
  align-items: center;

  img {
    width: 70px;
    height: 70px;
    border-radius: 70px;
    margin-right: 20px;
    object-fit: scale-down;
    background-color: #f1f1f1;
  }

  p {
    font-weight: 700;
    font-size: 16px;
  }
`;

export const Files = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: flex-start;
  font-weight: 600;
  margin-bottom: 10px;

  div {
    display: flex;
    flex-direction: row;
    height: 35px;
    padding: 0 15px;
    margin: 0 10px 10px 0;
    background-color: #f0f0f0;
    border-radius: 40px;
    align-items: center;
    justify-content: center;
    p {
      color: #000;
      text-align: center;
      flex: 1;
      font-size: 14px;
      word-break: break-all;
    }
  }
`;

export const Observation = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 80%;
  padding: 25px 50px;
  border-radius: 10px;
  background-color: #f0f0f0;

  p {
    color: #000;
  }
  @media (max-width: 850px) {
    max-width: 100%;
  }
`;

export const Resume = styled.div`
  width: 100%;
  padding: 25px;
  margin: 10px 0;
  background-color: #f0f0f0;
  border-radius: 10px;
  align-items: center;
  justify-content: center;

  button {
    display: flex;
    padding: 10px;
    width: 100%;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    font-size: 18px;
    color: #000;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 15px 0;
  flex-wrap: wrap;
  margin-bottom: 50px;
  button {
    display: flex;
    width: auto;
    padding: 15px;
    border-radius: 50px;
    margin: 0 15px;
    align-items: center;
    justify-content: center;
    font-size: 16px;
  }

  @media (max-width: 850px) {
    width: 100%;
    border-radius: 0px;
    button {
      margin: 15px 15px 0 0;
    }
  }
`;
